import { useEffect, useState } from "react";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";

const CustomSelect = ({ field, setValue, getValues, errors, trigger }) => {
  const [props, setProps] = useState(null);

  useEffect(() => {
    let value = null;
    if (Object.keys(getValues()).includes(field.name)) {
      if (Array.isArray(getValues()[field.name])) {
        value = field.options.filter((i) =>
          getValues()[field.name].includes(i.value)
        );
      } else {
        value = field.options.find((i) => i.value === getValues()[field.name]);
      }
    }

    setProps({
      defaultValue: value,
      placeholder: field?.placeholder,
      options: field.options,
      isMulti: field?.multiple,
      isDisabled: field?.disabled,
      onChange: (e) => {
        if (field?.onClick) {
          field.onClick(field?.multiple ? e.map((i) => i.value) : e.value);
        }
        if (field?.multiple) {
          setValue(
            field.name,
            e.map((i) => i.value)
          );
        } else {
          setValue(field.name, e.value);
        }
        trigger(field.name)
      },
      control: (styles) => ({
        ...styles,
        borderColor: field.name in errors ? "red" : styles.borderColor,
        "&:hover": {
          borderColor: errors.country ? "red" : styles["&:hover"].borderColor,
        },
      }),
    });
  }, [field.options]);

  return (
    props &&
    (field?.creatable ? <CreatableSelect {...props} /> : <Select {...props} />)
  );
};

export default CustomSelect;
